import { Grid, Stack, Tab, TabLabel, Tabs } from '@all-manager/design-system-v2';
import { Navigate, Route, Routes } from "react-router-dom";
import { ProviderDatabase } from "../../../../types";
import DocumentList from "../../../documents/components/DocumentList/DocumentList";
import ActivityTimeline from "../../../topics/components/ActivityTimeline/ActivityTimeline";
import CommunicationsTab from "../../../topics/components/CommunicationsTab/CommunicationsTab";
import ProviderContactsSidebar from "../ProviderContactsSidebar/ProviderContactsSidebar";
import ReminderTabContentWrapper from "../ReminderTabContentWrapper/ReminderTabContentWrapper";
import ContractList from "./ContractList";
import { ProviderTab, useProviderDetails } from "./useProviderDetails";

type Props = {
  provider: ProviderDatabase;
}

export default function ProviderDetails(props: Props) {
  const hook = useProviderDetails({ providerId: props.provider.id });

  function prefetchProps(tab: ProviderTab) {
    return {
      onMouseEnter: () => hook.handlePrefetch(tab),
      onFocus: () => hook.handlePrefetch(tab),
    };
  }

  return (
    <Grid container spacing={3} alignItems="flex-start">
      <Grid size={{ xs: 12, md: 4, lg: 3.5 }}>
        <ProviderContactsSidebar providerId={props.provider.id} />
      </Grid>

      <Grid size={{ xs: 12, md: 8, lg: 8.5 }}>
        <Stack spacing={3}>
          <Tabs
            divider
            value={hook.currentTab}
            onChange={hook.handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="Sections du prestataire"
          >
            <Tab
              value="contracts"
              label={<TabLabel label="Contrats" count={hook.counts.contracts} countLabel={`${hook.counts.contracts} contrats`} />}
              {...prefetchProps('contracts')}
            />
            <Tab
              value="reminders"
              label={<TabLabel label="Rappels" count={hook.counts.reminders} countLabel={`${hook.counts.reminders} rappels`} />}
              {...prefetchProps('reminders')}
            />
            <Tab
              value="documents"
              label={<TabLabel label="Documents" count={hook.counts.documents} countLabel={`${hook.counts.documents} documents`} />}
            />
            <Tab
              value="communications"
              label={<TabLabel label="Communications" count={hook.counts.communications} countLabel={`${hook.counts.communications} communications`} />}
            />
            <Tab value="historic" label="Historique" />
          </Tabs>

          <Routes>
            <Route index element={<Navigate to="contracts" replace />} />
            <Route path="contracts" element={<ContractList providerId={props.provider.id} />} />
            <Route path="reminders" element={<ReminderTabContentWrapper providerId={props.provider.id} />} />
            <Route
              path="documents"
              element={(
                <DocumentList
                  filters={{ providerId: props.provider.id }}
                  emptySubtitle="Retrouvez ici tous les documents associés à ce prestataire."
                  hideProvider
                />
              )}
            />
            <Route path="communications" element={<CommunicationsTab providerId={props.provider.id} />} />
            <Route path="historic" element={<ActivityTimeline providerId={props.provider.id} />} />
            <Route path="*" element={<Navigate to="contracts" replace />} />
          </Routes>
        </Stack>
      </Grid>
    </Grid>
  );
}
